import DOMPurify from 'dompurify';
import { EMAIL_REGEX } from '@/utils/email.js';

DOMPurify.addHook(
  'afterSanitizeAttributes',
  node => {
    if (node.tagName == 'A') {
      node.setAttribute('rel', 'noopener noreferrer ugc nofollow')
      node.setAttribute('target', '_blank')
    }
  }
);


let rootURL = process.env.OP_DEV_CONFIG['service-url'].replace(/\/$/, '');
if ((rootURL == 'service.ellacard.com') && (location.host == 'ellacard.com'))
  // We have a specail CloudFront behavior set up for ellacard.com/external-redirect so we can take advantage of
  // caching
  rootURL = '';

function wrapURL(url) {
  return url && `${rootURL}/external-redirect?url=${url}`;
}


const HTML_ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

function escapeHTML(text) {
  return text.replace(/[&<>"']/g, x => HTML_ESCAPE_MAP[x]);
}


function htmlToText(html) {
  const div = document.createElement('div')
  div.innerHTML = (html || '').replace(/<br\s*\/?>/gi, ' ').replace(/<\/?(div|p|li|tr|td|th|blockquote|pre|h[1-6])[^>]*>/gi, ' ')
  return div.textContent.replace(/\s+/g, ' ').trim()
}


// function cleanHTML(html) {
//   // This allows display-oriented tags, styles, and attributes but removes anything that could execute code
//   return DOMPurify.sanitize(html);
// }


function sanitizeHTML(html) {
  return DOMPurify.sanitize(html);
}

const HTTP_REGEX = new RegExp(/^https?:\/\//);
const LINK_REGEX = new RegExp(/(((ht|f)tps?:\/\/)|(\w[-+.%'~\w]*@))?([\w_-]+(?:(?:\.[\w_-]+)+))([\w.,@?^=%:\/~+#-]*[\w@?^=%\/~+#-])/g);
const LINK_TLDS = new Set([ 'com', 'net', 'edu', 'org', 'gov', 'info', 'xyz', 'site', 'me', 'co', 'us', 'uk', 'au', 'nz', 'eu', 'io', 'ai' ]);

function injectLinksPlainText(text) {
  // Use this function with content from a plain text input where we want to automatically highlight links and bind the
  // result as HTML, e.g. the event details field
  return escapeHTML(text).replace(
    LINK_REGEX,
    match => {
      if (HTTP_REGEX.test(match))
        return `<a href="${wrapURL(match)}" rel="noopener noreferrer ugc nofollow" target="_blank">${match}</a>`;
      if (EMAIL_REGEX.test(match))
        return `<a href="mailto:${match}" rel="noopener noreferrer ugc nofollow" target="_blank">${match}</a>`;
      const tld = match.substring(match.lastIndexOf('.') + 1);
      if (LINK_TLDS.has(tld))
        return `<a href="${wrapURL('http://' + match)}" rel="noopener noreferrer ugc nofollow" target="_blank">${match}</a>`;
      return match;
    }
  );
}

function injectLinksHTML(html) {
  // Use this function with content from an HTML input where we want also want to automatically highlight links that
  // look like URLs or email addresses but are not embedded in an a tag and bind the result as HTML, e.g. a text blob
  let depth = 0
  return DOMPurify.sanitize(
    html.replace(
      /(<(\/?)([a-zA-Z][a-zA-Z0-9]*)[^>]*>)|([^<]+)/g,
      (match, tag, slash, tagName, text) => {
        if (tag) {
          if (tagName.toLowerCase() == 'a')
            depth += slash ? -1 : 1;
          return tag;
        }
        if (depth > 0)
          return text;
        return text.replace(
          LINK_REGEX,
          match => {
            if (HTTP_REGEX.test(match))
              return `<a href="${wrapURL(match)}">${match}</a>`;
            if (EMAIL_REGEX.test(match))
              return `<a href="mailto:${match}">${match}</a>`;
            const tld = match.substring(match.lastIndexOf('.') + 1);
            if (LINK_TLDS.has(tld))
              return `<a href="${wrapURL('http://' + match)}">${match}</a>`;
            return match;
          }
        );
      }
    )
  );
}

// function injectLinks(text) {
//   if (!text)
//     return '';
//   text = cleanHTML(text);
//   let match;
//   let updated = '';
//   let lastMatchEndI = 0;
//   while (match = LINK_REGEX.exec(text)) {
//     updated += text.substring(lastMatchEndI, match.index);
//     if (match[0].startsWith('http')) {
//       updated += `<a href="${wrapURL(match[0])}" rel="noopener noreferrer ugc nofollow" target="_blank">${match[0]}</a>`;
//     } else if (EMAIL_REGEX.test(match[0])) {
//       updated += `<a href="mailto:${match[0]}" rel="noopener noreferrer ugc nofollow" target="_blank">${match[0]}</a>`;
//     } else {
//       const tld = match[0].substring(match[0].lastIndexOf('.') + 1);
//       if (LINK_TLDS.has(tld))
//         updated += `<a href="${wrapURL('http://' + match[0])}" rel="noopener noreferrer ugc nofollow" target="_blank">${match[0]}</a>`;
//       else
//         updated += match[0];
//     }
//     lastMatchEndI = match.index + match[0].length;
//   }
//   if (updated)
//     return updated + text.substring(lastMatchEndI);
//   return text;
// }

export { wrapURL, sanitizeHTML, htmlToText, injectLinksPlainText, injectLinksHTML };
